module.exports = __webpack_public_path__ + "static/media/custom-product-icon.744f9e0a.svg";